import { GetAccountListProps } from "@/services/accounts.service";

export interface ALFRProps {
  account_number?: string;
  account_type?: string;
  balance_control?: boolean[];
  commercial_zone?: string;
  locality?: string;
  social_reason?: string;
}

export const getALFilterRequest = (
  event: ALFRProps,
): Partial<GetAccountListProps> => {
  return {
    ...(event?.account_number
      ? {
          NroCuenta: event?.account_number,
        }
      : {}),
    ...(event?.account_type
      ? {
          TipoDeCuenta: event?.account_type,
        }
      : {}),
    ...(event?.balance_control
      ? {
          ControlDeSaldos: event?.balance_control?.[0],
        }
      : {}),
    ...(event?.commercial_zone
      ? {
          ZonaComercial: event?.commercial_zone,
        }
      : {}),
    ...(event?.locality
      ? {
          Localidad: event?.locality,
        }
      : {}),
    ...(event?.social_reason
      ? {
          RazonSocial: event?.social_reason,
        }
      : {}),
  };
};
